import { render, staticRenderFns } from "./ViewAccount.admin.vue?vue&type=template&id=59959349&scoped=true&"
import script from "./ViewAccount.admin.vue?vue&type=script&lang=js&"
export * from "./ViewAccount.admin.vue?vue&type=script&lang=js&"
import style0 from "./ViewAccount.admin.vue?vue&type=style&index=0&id=59959349&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59959349",
  null
  
)

export default component.exports